import { render, staticRenderFns } from "./FieldSwitch.vue?vue&type=template&id=de72a0b8&"
import script from "./FieldSwitch.vue?vue&type=script&lang=js&"
export * from "./FieldSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports